import { render, staticRenderFns } from "./MediakitTagsActionColumn.vue?vue&type=template&id=91b285e0&"
import script from "./MediakitTagsActionColumn.vue?vue&type=script&lang=js&"
export * from "./MediakitTagsActionColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports